import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightTarget as SpotlightTargetWithoutMigration } from '@atlaskit/onboarding';
import {
	SpotlightTarget as SpotlightTargetWithMigration,
	type SpotlightTargetProps,
} from '@atlassian/jira-spotlight/src/ui/SpotlightTarget.tsx';
import { canMigrateToNewSpotlightPackage } from '../common/canMigrateToNewSpotlightPackage.tsx';

export const ConditionalSpotlightTarget = ({
	children,
	name,
	isFullWidth,
}: SpotlightTargetProps): React.JSX.Element => {
	if (canMigrateToNewSpotlightPackage()) {
		return (
			<SpotlightTargetWithMigration name={name} isFullWidth={isFullWidth}>
				{children}
			</SpotlightTargetWithMigration>
		);
	}
	return <SpotlightTargetWithoutMigration name={name}>{children}</SpotlightTargetWithoutMigration>;
};
